<!-- @format -->

<template>
  <div id="app-box">
    <div id="app-div" :style="style">
      <div class="head">
        <img src="@/assets/img/logo.png" alt="英联·银关易" class="logo" />
        <div class="title">—— 全国进出口企业外贸数据信用概览 ——</div>
      </div>

      <div class="content">
        <div class="content-side left">
          <div style="text-align: right; padding-bottom: 30px">
            <p style="font-size: 23px; margin-bottom: 20px">GMV(元)</p>
            <p style="font-size: 43px; font-weight: bold">
              {{ (msgData.gmv_show && msgData.gmv_show.toLocaleString()) || '加载中' }}
            </p>
          </div>
          <div class="content-side-item" style="border-radius: 0 10px 0 0">
            <img class="content-side-item-icon" src="@/assets/img/icon_01_41_37.png" style="width: 41px; height: 37px" />
            <p class="content-side-item-title" style="margin-bottom: 6px;">订单数</p>
            <p class="content-side-item-con">{{ (msgData.company_qty && msgData.company_qty.toLocaleString()) || '加载中' }}</p>
          </div>
          <div class="content-side-item" style="background: #6612bd">
            <img class="content-side-item-icon" src="@/assets/img/icon_02_42_42.png" style="width: 42px; height: 42px" />
            <p class="content-side-item-title" style="margin-bottom: 6px;">近一年UV</p>
            <p class="content-side-item-con">{{ (msgData.uv && msgData.uv.toLocaleString()) || '加载中' }}</p>
          </div>
          <div class="content-side-item" style="background: #2712bd">
            <img class="content-side-item-icon" src="@/assets/img/icon_07.png" style="width: 38px; height: 38px" />
            <p class="content-side-item-title" style="margin-bottom: 6px;">有报关历史</p>
            <p class="content-side-item-title">企业数(家)</p>
            <p class="content-side-item-con">
              {{ (msgData.his_company_total && msgData.his_company_total.toLocaleString()) || '加载中' }}
            </p>
          </div>
          <div class="content-side-item" style="background: #2712bd">
            <img class="content-side-item-icon" src="@/assets/img/icon_03_38_38.png" style="width: 38px; height: 38px" />
            <p class="content-side-item-title" style="margin-bottom: 6px;">活跃企业数(家)</p>
            <p class="content-side-item-con">
              {{ getNumber() }}
            </p>
          </div>
        </div>
        <amap :map-data="msgData.activeAreaList" v-if="msgData.activeAreaList" />
        <div class="content-side right">
          <div style="text-align: center; padding-bottom: 30px;">
            <p style="font-size: 18px; margin-bottom: 10px;">数据统计</p>
            <p style="font-size: 18px">截至 {{ new Date().format('yyyy-MM-dd hh:mm') }}</p>
          </div>
          <div class="content-side-item" style="background: #8c24ff; border-radius: 10px 0 0 0">
            <img class="content-side-item-icon" src="@/assets/img/icon_04_44_44.png" style="width: 44px; height: 44px" />
            <p class="content-side-item-title" style="margin-bottom: 10px;">服务覆盖地区</p>
            <p class="content-side-item-title" style="margin-bottom: 6px;">{{ msgData.province_total || '加载中' }}个省</p>
            <p class="content-side-item-title" style="margin-bottom: 6px;">
              {{ msgData.autonomous_region_total || '加载中' }}个自治区
            </p>
            <p class="content-side-item-title" style="margin-bottom: 6px;">
              {{ msgData.municipality_total || '加载中' }}个直辖市
            </p>
          </div>
          <div class="content-side-item" style="background: #5512bd">
            <img class="content-side-item-icon" src="@/assets/img/icon_05_45_33.png" style="width: 45px; height: 33px" />
            <p class="content-side-item-title" style="margin-bottom: 6px;">服务网点数</p>
            <p class="content-side-item-title">(个)</p>
            <p class="content-side-item-con">超8000</p>
          </div>
          <div class="content-side-item" style="background: #1712bd">
            <img class="content-side-item-icon" src="@/assets/img/icon_06_38_38.png" style="width: 38px; height: 38px" />
            <p class="content-side-item-title" style="margin-bottom: 6px;">活跃城市数</p>
            <p class="content-side-item-title">(城)</p>
            <p class="content-side-item-con">{{ msgData.active_area_total || '加载中' }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import amap from '@/components/amap';
import request from '@/assets/js/request';
export default {
  name: 'App',
  components: { amap },
  data() {
    return {
      style: {},
      msgData: {
        // ysx_amt_total: 0,
        // service_company_total: 0,
        // ysx_company_total: 0,
        // active_import_export_enterprise_total: 0,
        // province_total: 0,
        // autonomous_region_total: 0,
        // municipality_total: 0,
        // service_network_total: 0,
        // active_area_total: 0
      }
    };
  },
  mounted() {
    this.setScale();
    window.addEventListener('resize', this.setScale, false);
    request({ url: '/api/rpt/out/dashboard' }).then(res => {
      if (res.success) {
        this.msgData = res.result;
      }
    });
  },
  methods: {
    setScale() {
      const width = 1920;
      const height = 1080;
      let ww = window.innerWidth / width;
      let wh = window.innerHeight / height;
      let scale = ww < wh ? ww : wh;
      let margin = window.innerHeight != 1080 ? (window.innerWidth - 1920 * scale) / 2 : 0;
      this.style = {
        transform: `scale(${scale})`,
        WebkitTransform: `scale(${scale})`,
        width: `${width}px`,
        height: `${height}px`,
        margin: margin ? `0 ${margin}px` : 0
      };
    },
    getNumber() {
      if (this.msgData.ysx_company_total) {
        return this.msgData.ysx_company_total.toLocaleString();
      } else {
        return '加载中';
      }
    }
  }
};
</script>

<style lang="less">
#app-box {
  background: url('../assets/img/bg.jpg') no-repeat;
  background-size: cover;
  background-position: center;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}
#app-div {
  padding-top: 88px;
  box-sizing: border-box;
  transform-origin: 0 0;
  display: flex;
  flex-direction: column;
  .content {
    display: flex;
    justify-content: space-between;
    flex: 1;
    #map {
      flex: 1;
    }
    .content-side {
      width: 310px;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      color: #fff;
      .content-side-item {
        text-align: center;
        background: #a124ff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        & + .content-side-item {
          margin-top: 4px;
        }
      }
      .content-side-item-icon {
        margin-bottom: 10px;
      }
      .content-side-item-title {
        font-size: 20px;
      }
      .content-side-item-con {
        font-size: 26px;
        font-weight: bold;
        margin-top: 16px;
      }
    }

    .left {
      .content-side-item {
        height: 165px;
      }
    }

    .right {
      .content-side-item {
        height: 220px;
      }
    }
  }
  .head {
    position: relative;
    height: 76px;
    display: flex;
    justify-content: center;
    .title {
      position: relative;
      color: #001dae;
      width: 1256px;
      height: 76px;
      line-height: 76px;
      text-align: center;
      font-size: 53px;
      font-weight: bold;
      background: url('../assets/img/title_bg.png') no-repeat;
      background-size: 100%;
      background-position: center;
    }
    .logo {
      position: absolute;
      left: 70px;
      top: 50%;
      margin-top: -25px;
      width: 219px;
      height: 51px;
    }
  }
}
</style>
